import appStore from "@utils/store";
import { getUserBackground, setUserBackground, updateUserBackground } from "../orbbyte";
import { EMPTY_USER_BKG } from "../../../contracts";
import { goTo } from "@utils/router";
import { getUserLanguage } from "@/utils/lang";
import { getDocById, updateDocById } from "../firebase";
import { parseFullName } from "@/utils/user";
import { addDays } from "date-fns";
import { getPlatform } from "@/utils/platform";
import { CalooAdminConfig } from "../admin";
import { sendSlackCaloo } from "../logging";

export async function createUserIfNoExists(user: any, route = true, fullname: string = "anonymous") {
    try {
        const info: any = await getDocById('users', user.uid);
        const idPost = info?.idPost || null;
        const nameInfo = parseFullName(fullname);

        // If the user does not exist, create a new user background
        if (!idPost) {
            const idPost = appStore.get("user")?.idPost;
            const background = idPost ? { idPost } : await routerUserWithoutBackground(user.uid, route);

            if (idPost) {
                await updateUserBackground({ data: { postName: user.uid, firebaseUser: user.uid }, idPost });
                goTo('/dashboard');
            }

            const data = {
                id: user.uid,
                uid: user.uid,
                firebaseUser: user.uid,
                email: user.email,
                username: info?.username ? info?.username : nameInfo.username,
                name: info?.name ? info?.name : nameInfo.name,
                surname: info?.surname ? info?.surname : nameInfo.surname,
                image: info?.image ? info?.image : "",
                accessCode: user.uid,
                type: info?.type ? info?.type : "oorenji-store",
                language: getUserLanguage(),
                idPost: background.idPost,
                backgroundCompleted: appStore.get("user")?.backgroundCompleted || false,
                premiumDateCaloo: addDays(new Date(), 3),
                promotionalCodes: [],
                stripeConnect: null
            };

            await updateDocById("users", user.uid, data);
            appStore.set('user', { ...info, ...data });
            const message = `New Caloo PARTNER (id: ${user.uid} - email: ${user.email})`;
            await sendSlackCaloo(user.uid, message);

        } else {
            if (info.type !== "caloo" && !info.premiumDateCaloo) {
                const premiumDateCaloo = addDays(new Date(), 3);
                await updateDocById("users", user.uid, { premiumDateCaloo, firebaseUser: user.uid });
                info.premiumDateCaloo = premiumDateCaloo;
            }

            appStore.set('user', { ...info, firebaseUser: user.uid });

            const background = await routerUserWithBackground(idPost, route);
            appStore.set('user', {
                ...info,
                backgroundCompleted: background.completed === 'true' || background.completed === true,
                firebaseUser: user.uid,
            });
        }
    } catch (error) {
        // Silenciado: no logs
    }
}

async function routerUserWithBackground(idPost: any, route = true) {
    const userBkg = (await getUserBackground({ idPost }))?.data[0] || {};
    if (route) {
        goTo('/dashboard');
    }
    return userBkg;
}

async function routerUserWithoutBackground(uid: any, route = true) {
    const background = await setUserBackground({
        data: EMPTY_USER_BKG(uid),
    });
    appStore.set('background', { ...background });

    if (route) {
        goTo('/dashboard');
    }

    return background;
}
